import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import ErrorMessage from '@/components/formik/messages/ErrorMessage'
import TextInput, { TextInputProps } from '@/components/ui/inputs/TextInput'

type TextFieldProps = FieldHookConfig<string> & TextInputProps

const MemoizedTextInput = React.memo<TextInputProps>(TextInput)

export default function TextField(props: TextFieldProps) {
  const [field, meta] = useField<string>(props)

  return (
    <MemoizedTextInput
      autoComplete="off"
      error={!!meta.error && meta.touched}
      helperText={!!meta.error && meta.touched && <ErrorMessage error={meta.error} />}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value ?? ''}
      {...props}
    />
  )
}
